import React from 'react'
import { COLORS } from '@btime/constants'
import { capitalizeFirstLetter } from '@btime/helpers'
import { gql } from '@apollo/client'
import { prop } from 'ramda'
import { useCleanFilterForRequest, useSearch } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import { cleanWhenEnabledFilterIsSet } from '../../modules/_helpers/filterByEnabled'

import { useQuery } from '../../utils/apollo/_helpers/useQuery'
import Text from '../../packages/kiti/components/presentation/Text'

const ListCounter = ({ entity, client, filterName, filters, fullText, ...props }) => {
  const { t } = useTranslation()
  const search = useSearch()

  const filter = cleanWhenEnabledFilterIsSet({ ...filters, ...useCleanFilterForRequest() })
  const funcName = capitalizeFirstLetter(entity) + 'Count'
  const queryName = entity + 'Count'

  const QUERY = gql`
    query ${funcName}($search: String, $filter: ${filterName}) {
      ${queryName}(search: $search, filter: $filter)
    }
  `

  const { data, loading } = useQuery(QUERY, {
    variables: { search, filter },
    client: client,
    fetchPolicy: 'cache-and-network'
  })

  if (loading) return false

  const count = prop(queryName, data)

  let label = `(${count})`
  if (!!fullText) label = `${count} ${t('counter.text')}`

  return (
    <Text size="small" color={COLORS.dark3} {...props}>
      {label}
    </Text>
  )
}

export default ListCounter
